import React from 'react';
import ActivosAsegurado from './index';

export default function EquipoOperacion() {
    return (<ActivosAsegurado cClasif={'Equipo de Operaciones'} cTitulo ={'Equipo de Operación'}/>);
}
